// Import Actions
import { subscribeToChannel, INIT_SOCKET, SEND_SOCKET, RECEIVE_SOCKET, DISCONNECT_SOCKET, SET_REDIRECT, REDIRECT, SET_MOUNTED, SET_APP_UPDATE, UPDATE_TABLE, ADD_CHANNEL, REMOVE_CHANNEL, SET_SUBSCRIBE_CHANNEL_NEED, SET_ENVIRONMENT, SET_WINDOW_FOCUS, SET_APP_EMBEDDED, INIT_PERSISTED_DATA, ADD_SHORTCUT, REMOVE_SHORTCUT } from './AppActions';
import { getPersistedData, persistData } from '../../util/persistor';
import { LOGOUT_USER } from '../User/AuthActions';

// Initial State
export const initialState = {
    socket: null,
    redirect: '',
    isMounted: false,
    tables: [
        // {
        //     id: 'users-list',
        //     activePage: 3,
        //     pageSize: null,
        //     searchFilters: [
        //         {
        //             property: 'name',
        //             value: 'test'
        //         }
        //     ],
        //     searchText: 'ma recherche'
        // }
    ],
    channels: [],
    needResubscribeToChannels: false,
    environment: {},
    isFocus: true,
    isUpdating: false,
};

const AppReducer = (state = initialState, action = {}) => {
    switch(action.type) {
        case SET_REDIRECT:
            return {
                ...state,
                redirect: action.redirect,
            };

        case REDIRECT:
            // TODO: Redirect in Header section
            return state;

        case INIT_SOCKET:
            return {
                ...state,
                socket: action.socket,
            };

        case SEND_SOCKET:
            false && process.env.NODE_ENV === 'development' && console.log('SEND_SOCKET', action.data);
            state.socket && state.socket.emit(action.data.type, action.data.data);
            return state;

        case RECEIVE_SOCKET:
            process.env.NODE_ENV === 'development' && console.log('RECEIVE_SOCKET', action.data);
            return state;

        case DISCONNECT_SOCKET:
            state.socket.disconnect();
            return state;

        case SET_MOUNTED:
            return {
                ...state,
                isMounted: true,
            };

        case SET_APP_UPDATE:
            return {
                ...state,
                isUpdating: true,
            };

        case UPDATE_TABLE:
            return {
                ...state,
                tables: [
                    ...state.tables.filter(table => table.id !== action.tableId),
                    {
                        id: action.tableId,
                        ...action.tableData,
                    },
                ],
            };

        case ADD_CHANNEL:
            return {
                ...state,
                channels: [].concat(state.channels, action.channel),
            };

        case REMOVE_CHANNEL:
            return {
                ...state,
                channels: state.channels.filter(channel => channel !== action.channel),
            };

        case SET_SUBSCRIBE_CHANNEL_NEED:
            return {
                ...state,
                needResubscribeToChannels: action.need,
            };

        case SET_ENVIRONMENT:
            return {
                ...state,
                environment: action.environment,
            };

        case SET_WINDOW_FOCUS:
            return {
                ...state,
                isFocus: action.isFocus,
            };

        case SET_APP_EMBEDDED:
            return {
                ...state,
                isEmbedded: action.isEmbedded,
            };

        case ADD_SHORTCUT: {
            const shortcuts = [].concat(state.shortcuts || [], [action.shortcut]);

            persistData('shortcuts', shortcuts);
            return {
                ...state,
                shortcuts,
            };
        }

        case REMOVE_SHORTCUT: {
            const shortcuts = state.shortcuts.filter(shortcut => shortcut.type !== action.shortcut.type && shortcut.id !== action.shortcut.id);
            persistData('shortcuts', shortcuts);
            return {
                ...state,
                shortcuts,
            };
        }

        // case LOGIN_USER:
        case LOGOUT_USER:
            return {
                ...state,
                tables: [],
                isMounted: true,
            };

        case INIT_PERSISTED_DATA:
            return {
                ...state,
                shortcuts: getPersistedData('shortcuts', []),
            };

        default:
            return state;
    }
};

// Export Reducer
export default AppReducer;
